/**
 * Probability slider utilities
 */

/**
 * Clamp probability value between 0 and 100
 */
export const clampProbability = (n: number): number => Math.min(100, Math.max(0, Math.round(n)));

/**
 * Interpolate color: 0=red, 50=yellow, 100=green (matches probability slider gradient)
 */
export function getProbabilityColor(pct: number): string {
  const r = (a: number, b: number, t: number) => Math.round(a + (b - a) * t);
  if (pct <= 50) {
    const t = pct / 50;
    return `rgb(${r(239, 68, t)} ${r(68, 179, t)} ${r(68, 8, t)})`;
  }
  const t = (pct - 50) / 50;
  return `rgb(${r(234, 34, t)} ${r(179, 197, t)} ${r(8, 94, t)})`;
}

/**
 * Validate probability value
 */
export function isValidProbability(value: any): boolean {
  const num = Number(value);
  return !Number.isNaN(num) && num >= 0 && num <= 100;
}

/**
 * Format probability for display
 */
export function formatProbability(value: any): string {
  const num = clampProbability(Number(value) || 0);
  return `${num}%`;
}

/**
 * Parse probability from string
 */
export function parseProbability(value: string): number {
  const num = Number(value);
  return isValidProbability(num) ? clampProbability(num) : 0;
}

/**
 * Get probability label
 */
export function getProbabilityLabel(pct: number): string {
  if (pct === 0) return "No chance";
  if (pct < 25) return "Very unlikely";
  if (pct < 50) return "Unlikely";
  if (pct === 50) return "Even odds";
  if (pct < 75) return "Likely";
  if (pct < 100) return "Very likely";
  return "Certain";
}
